<!--
  Created 29.05.2023
  General accordion component.
  Has by default some styling, but should suit most use cases.
-->
<template>
  <div>
    <slot name="preTitle" />
    <button
      class="flex w-full items-center border-b border-gray-200 text-black"
      :class="buttonClass"
      :aria-expanded="isOpen"
      :aria-controls="`collapse-${uid}`"
      @click="$emit('toggle', (isOpen = !isOpen))">
      <slot name="title" />
      <template v-if="!hideButtonIcons">
        <PlusSmallIcon
          v-if="!isOpen"
          class="ml-auto h-6 w-6"
          aria-hidden="true" />
        <MinusSmallIcon
          v-else
          class="ml-auto h-6 w-6"
          aria-hidden="true" />
      </template>
    </button>
    <div
      v-show="isOpen"
      :id="`collapse-${uid}`">
      <slot
        name="content"
        :state="state" />
    </div>
  </div>
</template>

<script setup>

import {
  ref, watch,
} from 'vue';
import {
  PlusSmallIcon, MinusSmallIcon,
} from '@heroicons/vue/24/outline';

const props = defineProps({
  state: {
    type: Boolean,
    default: false,
  },
  buttonClass: {
    type: String,
    default: 'p-4 hover:bg-teal-100',
  },
  hideButtonIcons: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['toggle']);

const isOpen = ref(props.state);
const uid = Math.random().toString(36).substring(2, 10);

watch(() => props.state, () => {
  isOpen.value = props.state;
});

</script>
